/**
 * Shared transaction document-type constants.
 *
 * These values correspond to batch type IDs and subledger codes used across
 * all transaction document components (AR invoice, AP invoice, sales order,
 * purchase order, shipment, work order, etc.).
 *
 * Import from here instead of defining locally so that source-document flows
 * (e.g. "create AR invoice from shipment/SO/WO") can reference the target
 * document type without circular dependencies or duplication.
 */

// ---- Subledger codes ----
export const SUBLEDGER_AR = 'ar';
export const SUBLEDGER_AP = 'ap';
export const SUBLEDGER_SALES_ORDERS = 'salesorders';
export const SUBLEDGER_PURCHASE_ORDERS = 'purchaseorders';
export const SUBLEDGER_QUOTES = 'quotes';

// ---- New-document route param sentinels ----
export const NEW_DOC_AR = 'newAR';
export const NEW_DOC_AP = 'newAP';
export const NEW_DOC_SALES_ORDER = 'newSalesOrder';
export const NEW_DOC_PURCHASE_ORDER = 'newPurchaseOrder';
export const NEW_DOC_QUOTE = 'newQuote';
export const NEW_DOC_SHIPMENT_SS = 'newSS';
export const NEW_DOC_SHIPMENT_PS = 'newPS';

// ---- Batch / document type IDs ----
export const DOC_TYPE_AR_INVOICE = '2';
export const DOC_TYPE_AP_INVOICE = '4';
export const DOC_TYPE_QUOTE = '8';
export const DOC_TYPE_SALES_ORDER = '9';
export const DOC_TYPE_PURCHASE_ORDER = '10';
export const DOC_TYPE_SHIPMENT = '11';
export const DOC_TYPE_WORK_ORDER = '6'; // work order batch type

// ---- Payment batch type IDs ----
export const PAYMENT_BATCH_TYPE_AR = 3;
export const PAYMENT_BATCH_TYPE_AP = 5;
